import i18n from '../../../../i18n'
import { DOC_FLOW_API_URL } from '../../DocFlow.constants'

import {
  DOC_FLOW_MAPPING_RESULT_TABLE_ACTION_DELETE,
  DOC_FLOW_MAPPING_RESULT_TABLE_ACTION_EDIT_RECIPIENT,
  DOC_FLOW_MAPPING_RESULT_TABLE_CONFIG_URL,
  DOC_FLOW_MAPPING_RESULT_TABLE_FILTER_STATE_URL,
  DOC_FLOW_MAPPING_RESULT_TABLE_MASS_ACTION_DELETE,
} from './DocFlowMappingResultTable.constants'

export function getDocFlowMapppingResultTableApiUrls(id, fileId) {
  return {
    filterStateApi: `${DOC_FLOW_MAPPING_RESULT_TABLE_FILTER_STATE_URL}?object_id=${fileId}`,
    listApi: `${DOC_FLOW_API_URL}${id}/uploading-files/${fileId}/results/filter/`,
    tableConfigApi: DOC_FLOW_MAPPING_RESULT_TABLE_CONFIG_URL,
  }
}

export function getDocFlowMapppingResultFilterApi(id) {
  return `${DOC_FLOW_API_URL}${id}/document-stapling-uploading-results/single-field/`
}

export function getDocFlowMapppingResultTableItemActions() {
  return [
    {
      label: 'DocumentStapling.CombiningTableEditRecipientActionOptionKey',
      value: DOC_FLOW_MAPPING_RESULT_TABLE_ACTION_EDIT_RECIPIENT,
    },
    null,
    {
      label: 'DocumentStaplingTable.DeleteActionOptionKey',
      value: DOC_FLOW_MAPPING_RESULT_TABLE_ACTION_DELETE,
    },
  ]
}

export function getDocFlowMapppingResultNotificationTitle({
  action,
  count,
  totalCount,
}) {
  const types = {
    [DOC_FLOW_MAPPING_RESULT_TABLE_ACTION_DELETE]: i18n.t(
      'Notification.CommonTitleDeletedKey'
    ),
    [DOC_FLOW_MAPPING_RESULT_TABLE_ACTION_EDIT_RECIPIENT]: i18n.t(
      'Notification.CommonTitleSavedKey'
    ),
    [DOC_FLOW_MAPPING_RESULT_TABLE_MASS_ACTION_DELETE]: i18n.t(
      'Notification.CommonTitleMassDeletedKey',
      {
        count,
        totalCount,
      }
    ),
  }

  return types[action] || null
}

export function getDocFlowMappingResultItemPosition({
  item,
  pagination,
  tableItems,
}) {
  const indexInPage = tableItems.items.findIndex(({ id }) => id === item.id)

  return (pagination.page - 1) * pagination.pageSize + indexInPage + 1
}

export function getDocFlowMapppingResultMassActions() {
  return [
    {
      label: i18n.t('DocumentStaplingTable.DeleteActionOptionKey'),
      value: DOC_FLOW_MAPPING_RESULT_TABLE_MASS_ACTION_DELETE,
    },
  ]
}
